import * as echarts from "echarts";
export function sqOptions(datas, timeDatas, unit = "") {
  let yData1 = [],
    yData2 = [],
    yData3 = [],
    legends = [],
    series = [],
    color = "7,44,90",
    colorList = ["0,146,246", "7,44,90", "0,212,199"];
  if (datas && datas.length > 0) {
    datas.map((item, index) => {
      if (index == 0) yData1 = item.echartsData;
      else if (index == 1) yData2 = item.echartsData;
      if (index == 2) yData3 = item.echartsData;
      legends.push(item.name);
      let seriesData = [];
      item.echartsData.map((it, idx) => {
        seriesData.push([item.indexs[idx], item.echartsData[idx]]);
      });
      series.push({
        name: item.name,
        type: "line",
        symbolSize: 0,
        smooth: true,
        itemStyle: {
          normal: {
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: `rgba(${color},0.3)`
                },
                {
                  offset: 1,
                  color: `rgba(${colorList[index]},0.9)`
                }
              ])
            }
          }
        },
        data: seriesData
      });
    });
  }
  let max = Math.max(
    ...[Math.max(...yData1), Math.max(...yData2), Math.max(...yData3)]
  );
  let min = Math.min(
    ...[Math.min(...yData1), Math.min(...yData2), Math.min(...yData3)]
  );
  return {
    color: ["#FF920F", "#01FFFF", "#0FABFF"],
    grid: {
      left: "15%",
      right: "7%",
      bottom: "15%",
      top: "26%"
    },
    tooltip: {
      trigger: "axis",
      position: ["50%", "20%"]
    },
    legend: {
      x: "5%",
      top: "8",
      textStyle: {
        color: "#fff"
      },
      data: legends
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        axisLabel: {
          color: "#fff"
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#397cbc"
          }
        },
        data: timeDatas
      }
    ],
    yAxis: [
      {
        name: unit,
        nameTextStyle: {
          fontSize: "15px",
          padding: [0, 0, -20, 0]
        },
        type: "value",
        axisLine: {
          lineStyle: {
            color: "#fff"
          }
        },
        splitLine: {
          show: false
        },
        max: max + 1,
        min: min
      }
    ],
    series
  };
}
